// // import React, { useState, useEffect } from "react";
// // import { useWeightContext } from "../context/appContext";
// // import ContainerWithTitle from "../../../containers/title.container";

// // const QuestionSixteen = ({ onNext, onPrev }) => {
// //   const { payload, setPayload, currentPage, setCurrentPage, setErrorMessage } =
// //     useWeightContext();
// //   const [file, setFile] = useState(null);
// //   const [fileUrl, setFileUrl] = useState(payload?.blood_test_url || "");

// //   useEffect(() => {
// //     setFileUrl(payload?.blood_test_url || "");
// //   }, [currentPage, payload]);

// //   const handleFileChange = (event) => {
// //     const selectedFile = event.target.files[0];
// //     if (selectedFile) {
// //       // Assuming the file is validated and sent to an API
// //       // For now, we'll simulate storing the file and getting a URL
// //       setFile(selectedFile);
// //       setErrorMessage(null);
// //       // In a real scenario, you'd upload the file to an API and get a URL
// //       // For demo purposes, we'll use a placeholder URL
// //       const simulatedApiUrl = URL.createObjectURL(selectedFile);
// //       setFileUrl(simulatedApiUrl);
// //     }
// //   };

// //   const handleSubmit = (event) => {
// //     event.preventDefault();
// //     // Since the upload is optional, we proceed even if no file is selected
// //     onNext(fileUrl || "");
// //   };

// //   return (
// //     <ContainerWithTitle
// //       title="Upload your latest blood test (optional)"
// //       handleBack={onPrev}
// //       handleNext={handleSubmit}
// //       isContinueButton={true} // Always enabled since upload is optional
// //     >
// //       <div className="file-upload-container">
// //         <input
// //           type="file"
// //           accept="image/*,.pdf"
// //           onChange={handleFileChange}
// //           className="input mt-5"
// //         />
// //         {fileUrl && (
// //           <p className="mt-3 text-sm text-gray-600">
// //             File selected: {file?.name || "Uploaded file"}
// //           </p>
// //         )}
// //       </div>
// //     </ContainerWithTitle>
// //   );
// // };

// // export default QuestionSixteen;

// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { useWeightContext } from "../context/appContext";
// import ContainerWithTitle from "../../../containers/title.container";
// import { apiUrl } from "../../../config/config";

// const QuestionSixteen = ({ onNext, onPrev }) => {
//   const { payload, setPayload, currentPage, setCurrentPage, setErrorMessage } =
//     useWeightContext();
//   const [file, setFile] = useState(null);
//   const [fileUrl, setFileUrl] = useState(payload?.blood_test_url || "");
//   const [uploading, setUploading] = useState(false);

//   console.log("fileUrl",fileUrl)

//   useEffect(() => {
//     setFileUrl(payload?.blood_test_url || "");
//   }, [currentPage, payload]);

//   const handleFileChange = async (event) => {
//     const selectedFile = event.target.files[0];
//     if (selectedFile) {
//       setFile(selectedFile);
//       setErrorMessage(null);
//       setUploading(true);

//       try {
//         const formData = new FormData();
//         formData.append("file", selectedFile);

//         const response = await axios.post(
//           `${apiUrl}/api/v1/diagnose/upload-file`,
//           formData,
//           {
//             headers: {
//               "Content-Type": "multipart/form-data",
//             },
//           }
//         );

//         const uploadedUrl = response.data.fileUrl; // Adjust based on actual API response structure
//         setFileUrl(uploadedUrl);
//       } catch (error) {
//         setErrorMessage("Failed to upload file. Please try again.");
//         setFile(null);
//         setFileUrl("");
//       } finally {
//         setUploading(false);
//       }
//     }
//   };

//   const handleSubmit = (event) => {
//     event.preventDefault();
//     if (uploading) {
//       setErrorMessage("Please wait until the file is uploaded.");
//       return;
//     }
//     // Since the upload is optional, we proceed even if no file is selected
//     onNext(fileUrl || "");
//   };

//   return (
//     <ContainerWithTitle
//       title="Upload your latest blood test (optional)"
//       handleBack={onPrev}
//       handleNext={handleSubmit}
//       isContinueButton={true} // Always enabled since upload is optional
//     >
//       <div className="file-upload-container">
//         <input
//           type="file"
//           accept="image/*,.pdf"
//           onChange={handleFileChange}
//           className="input mt-5"
//           disabled={uploading}
//         />
//         {uploading && (
//           <p className="mt-3 text-sm text-gray-600">Uploading...</p>
//         )}
//         {fileUrl && !uploading && (
//           <p className="mt-3 text-sm text-gray-600">
//             File uploaded: {file?.name || "Uploaded file"}
//           </p>
//         )}
//       </div>
//     </ContainerWithTitle>
//   );
// };

// export default QuestionSixteen;

import React, { useState, useEffect } from "react";
import axios from "axios";
import { useWeightContext } from "../context/appContext";
import ContainerWithTitle from "../../../containers/title.container";
import { apiUrl } from "../../../config/config";

const QuestionSixteen = ({ onNext, onPrev }) => {
  const { payload, setPayload, currentPage, setCurrentPage, setErrorMessage } =
    useWeightContext();
  const [file, setFile] = useState(null);
  const [fileUrl, setFileUrl] = useState(payload?.blood_test_url || "");
  const [uploading, setUploading] = useState(false);

  useEffect(() => {
    setFileUrl(payload?.blood_test_url || "");
  }, [currentPage, payload]);

  const handleFileChange = async (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
      setErrorMessage(null);
      setUploading(true);

      try {
        const formData = new FormData();
        formData.append("file", selectedFile);

        const response = await axios.post(
          `${apiUrl}/api/v1/diagnose/upload-file`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        const uploadedUrl = response.data.fileUrl;
        setFileUrl(uploadedUrl);
      } catch (error) {
        setErrorMessage("Failed to upload file. Please try again.");
        setFile(null);
        setFileUrl("");
      } finally {
        setUploading(false);
      }
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (uploading) {
      setErrorMessage("Please wait until the file is uploaded.");
      return;
    }
    window.gtag({
      event: "user_blood_test_url",
      data: {
        blood_test_url: fileUrl,
      },
    });
    if (window.fbq) {
      window.fbq("track", "user_blood_test_url", {
        blood_test_url: fileUrl,
      });
    }
    onNext(fileUrl || "");
  };

  return (
    <ContainerWithTitle
      title="Upload your latest blood test report (optional)"
      handleBack={onPrev}
      handleNext={handleSubmit}
      isContinueButton={true}
    >
      <div className="max-w-md mx-auto p-6 bg-white rounded-xl shadow-lg">
        <label
          htmlFor="file-upload"
          className="flex items-center justify-between w-full p-4 bg-gray-50 border-2 border-dashed border-[#2F412F] rounded-lg cursor-pointer hover:bg-gray-100 transition-colors duration-200"
        >
          <span className="text-gray-600 text-sm font-medium truncate flex-1">
            {file ? file.name : "Choose a file (PDF or Image)"}
          </span>
          <span className="bg-[#2F412F] text-white px-4 py-2 rounded-md text-sm font-semibold hover:bg-[#3A503A] transition-colors duration-200">
            Browse
          </span>
        </label>
        <input
          id="file-upload"
          type="file"
          accept="image/*,.pdf"
          onChange={handleFileChange}
          className="hidden"
          disabled={uploading}
        />
        {uploading && (
          <div className="mt-4 flex items-center space-x-2">
            <svg
              className="animate-spin h-5 w-5 text-[#2F412F]"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
              />
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8v8h8a8 8 0 01-8 8 8 8 0 01-8-8z"
              />
            </svg>
            <p className="text-sm text-gray-600">Uploading...</p>
          </div>
        )}
        {fileUrl && !uploading && (
          <div className="mt-4 p-3 bg-green-100 rounded-lg flex items-center space-x-2">
            <svg
              className="h-5 w-5 text-[#2F412F]"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M5 13l4 4L19 7"
              />
            </svg>
            <p className="text-sm text-[#2F412F] truncate">
              File uploaded: {file?.name || "Uploaded file"}
            </p>
          </div>
        )}
      </div>
    </ContainerWithTitle>
  );
};

export default QuestionSixteen;
